module.exports = "<?xml version=\"1.0\" encoding=\"UTF-8\" standalone=\"no\"?> <svg width=191px height=288px viewBox=\"0 0 191 288\" version=1.1 xmlns=http://www.w3.org/2000/svg xmlns:xlink=http://www.w3.org/1999/xlink> <polygon points=\"95.5 288 0 0 191 5.68434189e-14\"></polygon> </svg> ";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/arrow-slim-bottom.svg
// module id = 264
// module chunks = 0